
import api, { apiInternal } from '../api';


export async function getJobs() {
  const { data } = await api.post(`${apiInternal}/getJobs`, {});
 
  return data;
}